/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_Link_Body_PlainInputs */



/**
* | output |
* | --- |
* | "We sent a sign-in link to your email. Open it on this device." |
*
* @param {Signin_Link_Body_PlainInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const signin_link_body_plain = /** @type {((inputs?: Signin_Link_Body_PlainInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_Link_Body_PlainInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("We sent a sign-in link to your email. Open it on this device.")
});